import React, { Component } from 'react'
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory } from 'react-router'
import Megamenu from './components/header.jsx'
import ReactGA from 'react-ga';
import Footer from './components/footer.jsx'
import Slide from './components/slideshow.jsx'
import ContactPage from './components/Contact.jsx';
import Recrutement from './components/Recrutement.jsx';
import ContactTech from './components/ContactTech.jsx';
import TestFileSubmission from './components/TestFileSubmission.jsx';
import NosMissions from './components/mission.jsx'
import NotreUsine from './components/usine.jsx'
import SecondMenu from './components/header_interne.jsx'
import NosValeurs from './components/valeur.jsx'
import TerangaPlus from './components/terangaPlus.jsx'
import Teranga from './components/teranga.jsx'
import Certificate from './components/certification.jsx'
import NosPartenaires from './components/partenaire.jsx'
import QuiSommesNous from './components/qui-sommes-nous.jsx'
import ActionRSE from './components/rse.jsx'
import RechercheInnovation from './components/recherche_innovation.jsx'
import ScrollPage from './components/scrollpage.jsx'
import TechConseil from './components/tech-conseil.jsx'
import ssl from './components/ssl1'
import ssl2 from './components/ssl2'




ReactGA.initialize('UA-137808259-1');

function logPageView() {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  ReactGA.pageview(window.location.pathname + window.location.search);
}

let NotFound = (props) => (
  <div className="content container">
    <h6 className="notfound text-center">Page not found</h6>
  </div>
)

NotFound = (NotFound)


class App extends Component {
  render() {
    return (
      <Router history={browserHistory} onUpdate={logPageView} >
              <Route path='.well-known/acme-challenge/XXy-Dv2aOebtLQtQ0ZXwxHBjKsaBxdrLgDKg8rNbMWw' component={ssl2} />
        <Route path='.well-known/acme-challenge/45veqY-MYHrz8x5_LJHwCDPZ4PHLkk5-699i_rF8OEA' component={ssl}/>

        <Route path='/' component={Megamenu}>
        <IndexRoute component={Slide}/>
        </Route>
        <Route path='/' component={SecondMenu}>
        <Route path='#greenagro' component={ScrollPage}/>
        <Route path='contact' component={ContactPage}/>
        <Route path='contact-tech' component={ContactTech}/>
        <Route path='test' component={TestFileSubmission}/>
        <Route path='recrutement' component={Recrutement}/>
        <Route path='nos-missions' component={NosMissions}/>
        <Route path='notre-usine' component={NotreUsine}/>
        <Route path='qui-sommes-nous' component={QuiSommesNous}/>
        <Route path='nos-partenaires' component={NosPartenaires}/>
        <Route path='nos-engagements' component={NosValeurs}/>
        <Route path='certification-bio' component={Certificate}/>
        <Route path='produits/teranga' component={Teranga}/>
        <Route path='produits/teranga-plus' component={TerangaPlus}/>
        <Route path='rse' component={ActionRSE}/>
      <Route path='technicien-conseil' component={TechConseil}/>
        <Route path='recherche-et-innovation' component={RechercheInnovation}/>


        </Route>
        <Route>

           <Route path='/*' component={NotFound} />
        </Route>




      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js